/*********************** Custom JS for Boost AI Search & Discovery  ************************/
const customize = {
  removeOOSProductSwatches: (componentRegistry) => {
    componentRegistry.useComponentPlugin("ProductSwatch", {
      name: "Customize swatches",
      enabled: true,
      apply: () => ({
        props: (props) => {
          props.maxItem = 100; // Show all swatches by increasing number of swatches displayed to 100 (optional)
          return props;
        },
        afterRender(element) {
          const swatchOptions = element?.getParams()?.props?.options;
          const productData =
            componentRegistry
              .getNearestParentElm(element, "ProductItemWidget")
              ?.getParams()?.props?.product ||
            componentRegistry
              .getNearestParentElm(element, "QuickView")
              ?.getParams()?.props?.productData;
          if (swatchOptions?.length && productData) {
            const productVariants = productData.variants || [];
            swatchOptions.forEach((option) => {
              const optionValue = option.value;
              option.available = checkOptionStatus(
                productVariants,
                optionValue
              );
              if (!option.available) {
                const swatchOption = document.querySelector(
                  `label[for*="${option.id}"]`
                );
                if (
                  swatchOption &&
                  swatchOption.closest(".boost-sd__product-swatch-option")
                ) {
                  swatchOption
                    .closest(".boost-sd__product-swatch-option")
                    .classList.add("sold-out");
                }
              }
            });
          }
        },
      }),
    });
  },
};

function checkOptionStatus(variants, optionValue) {
  for (let i = 0; i < variants.length; i++) {
    const variant = variants[i];
    const variantOptions = variant.title?.split(" / ") || [];
    if (
      variantOptions.some(
        (option) =>
          option.toLowerCase() === optionValue.toLowerCase() &&
          variant.available
      )
    ) {
      return true;
    }
  }
  return false;
}


window.__BoostCustomization__ = (window.__BoostCustomization__ ?? []).concat([
  customize.removeOOSProductSwatches,
]);

if (window.boostSDAppConfig) { window.boostSDAppConfig.integration = Object.assign({ wishlists: 'smart' }, window.boostSDAppConfig.integration || {}); }